/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconWrapper } from '../IconWrapper';
import type { IconWrapperProps } from '../IconWrapper';
export default (props: IconWrapperProps) =>
  createElement(
    IconWrapper,
    props,
    <path
      fill="currentColor"
      d="M18.75 14.125v-1a1 1 0 0 0-1 1h1Zm2.25 0v1a1 1 0 0 0 .941-1.338l-.941.338Zm-2.195-5.89-.976.22c.011.05.026.098.044.145l.932-.364ZM17.67 5.584l-.867.497c.01.02.022.038.034.056l.833-.553Zm-.1-.148-.82.572a1 1 0 0 0 .097.12l.723-.692ZM6.375 16.528h1a1 1 0 0 0-.421-.815l-.579.815Zm0 5.222h-1a1 1 0 0 0 1 1v-1Zm9 0v1a1 1 0 0 0 1-1h-1Zm0-3v-1a1 1 0 0 0-1 1h1Zm3.375-3.625H21v-2h-2.25v2Zm2.25-1 .941-.338v-.002a.408.408 0 0 0-.003-.008l-.01-.029-.04-.11-.151-.416c-.128-.354-.31-.854-.523-1.432a219.02 219.02 0 0 0-1.478-3.918l-1.863.728c.494 1.263 1.04 2.728 1.464 3.88a337.47 337.47 0 0 1 .718 1.973l.003.008v.001l.942-.337Zm-1.22-6.109a8.96 8.96 0 0 0-1.275-2.986l-1.667 1.106c.462.696.802 1.48.991 2.32l1.951-.44Zm-1.241-2.93a1.767 1.767 0 0 0-.245-.342l-1.446 1.383a.695.695 0 0 1-.046-.053l-.014-.02.016.026 1.735-.994Zm-.147-.222A8.99 8.99 0 0 0 11 1v2a6.991 6.991 0 0 1 5.75 3.007l1.642-1.143ZM11 1a9 9 0 0 0-9 9h2a7 7 0 0 1 7-7V1Zm-9 9a8.99 8.99 0 0 0 3.796 7.344l1.158-1.631A6.99 6.99 0 0 1 4 10H2Zm3.375 6.528v5.222h2v-5.222h-2Zm1 6.222h9v-2h-9v2Zm10-1v-3h-2v3h2Zm-1-2h.375v-2h-.375v2Zm.375 0a4 4 0 0 0 4-4h-2a2 2 0 0 1-2 2v2Zm4-4v-1.625h-2v1.625h2Z"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m8 10 2 2 4-4"
    />
  );
